import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../i18n';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import withBaseComponent from '../withBaseComponent';
import {mapDispatchToProps} from "../mapDispatchToProps"
import Formsy from 'formsy-react';
import Input from '../forms/Input'
import ButtonLoading from "../common/ButtonLoading"
import { trackingEvent } from "./layouts/GoogleAnalytics.js"

class Account extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props);

    this.state = {
      isShowIssue: false,
      isShowIssueTimeout: false,
      modalEditName: false,
      modalDeletePc: false,
      modalDeletePcObj: null,
      isProcessing: false,
    };

    this.toggleEditName = this.toggleEditName.bind(this);
    this.getOfficeName = this.getOfficeName.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.isNullOffice = this.isNullOffice.bind(this);
  }

  componentWillMount() {
    this.props.userActions.officeList().then(res => {
      return res;
    });
  }

  trackingEditOffice() {
    trackingEvent("Office", "編集")
    this.toggleEditName()
  }

  toggleEditName() {
    this.setState(prevState => ({
      modalEditName: !prevState.modalEditName
    }));
  }

  isNullOffice() {
    return this.props.officeData ? false : true;
  }

  getOfficeName() {
    return this.props.officeData ? this.props.officeData.name : i18n.t('account.empty');
  }

  submitForm(model) {
    if (this.hasError())
      return

    this.setState({isProcessing: true})
    if(model.id) {
      this.props.userActions.officeUpdate(model.id, {office: model}).then(res => {
        this.setState({isProcessing: false})
        this.toggleEditName()
        return res
      })
    } else {
      this.props.userActions.officeCreate({office: model}).then(res => {
        this.setState({isProcessing: false})
        this.toggleEditName()
        return res
      })
    }
  }

  render() {
    const { isProcessing } = this.state;

    return (
      <div className="account-container small-container">
        <div className="row no-gutters">
          <div className="col-sm-12 title padl-0">{i18n.t("account.title_account_name")}</div>
          <div className="col-sm-12 content-body">
            <div className="row mfc-line">
              <div className="col-sm-8 mfc-label">
                {this.getOfficeName()}
              </div>
              <div className="col-sm-4 text-right">
                <button type="button" className="btn mfc-btn-gray small" onClick={() => this.trackingEditOffice()}>{i18n.t("common.edit")}</button>
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.modalEditName} className={this.props.className} centered={true}>
          <Formsy ref="form" onInvalidSubmit={this.showErrors} onSubmit={this.submitForm} onValid={this.enableButton} onInvalid={this.disableButton}>
            <ModalHeader toggle={this.toggleEditName}>{i18n.t('account.modal_editname_header')}</ModalHeader>
            <ModalBody>
              <div className="form-group">
                <Input type="hidden" name="id" value={this.isNullOffice() ? '' : this.props.officeData.id} />
                <label htmlFor="exampleInputEmail1">{i18n.t('account.modal_editname_body_officename')}</label>
                <Input type="text" name="name" value={this.getOfficeName()}
                       placeholder={i18n.t('account.modal_editname_body_officename')}
                       validations="maxLength: 30"
                       validationError={i18n.t('validations.offices.maxLength', {length: 30})}
                       required />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button onClick={this.toggleEditName} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
              <ButtonLoading text={i18n.t('common.save')} className="btn mfc-btn-blue medium" type="submit" isProcessing={isProcessing} />
            </ModalFooter>
          </Formsy>
        </Modal>



      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    officeData: state.user.get('officeData') || null,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Account)
